// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__uX8s9","label":"Input_label__00MHA","invalid":"Input_invalid__rJ4fT"};